import { QuestionnaireSectionStatus } from "../../../api/src/types";

export const TOTAL_STEPS = 5;

export interface ProgressCalculationParams {
  questionnaireSections?: { status: QuestionnaireSectionStatus }[];
  isPrenupPaid: boolean;
  hasFinancials: boolean;
  isDocumentReviewed: boolean;
  isNotarizationComplete: boolean;
}

export function calculateCurrentStep({
  questionnaireSections,
  isPrenupPaid,
  hasFinancials,
  isDocumentReviewed,
  isNotarizationComplete,
}: ProgressCalculationParams): number {
  let currentStep = 0;

  if (!questionnaireSections) return currentStep;

  const isBasicInfoComplete =
    questionnaireSections[0]?.status === QuestionnaireSectionStatus.COMPLETED;

  if (isBasicInfoComplete) {
    currentStep = 1;

    const isQuestionnairePt1Complete = questionnaireSections
      .slice(0, 4)
      .every(
        (section) =>
          section.status === QuestionnaireSectionStatus.COMPLETED ||
          section.status === QuestionnaireSectionStatus.NOT_APPLICABLE,
      );

    if (isQuestionnairePt1Complete && isPrenupPaid) {
      currentStep = 2;

      const isQuestionnairePt2Complete = questionnaireSections
        .slice(4)
        .every(
          (section) =>
            section.status === QuestionnaireSectionStatus.COMPLETED ||
            section.status === QuestionnaireSectionStatus.NOT_APPLICABLE,
        );

      if (isQuestionnairePt2Complete) {
        currentStep = 3;

        if (hasFinancials || isDocumentReviewed) {
          currentStep = 4;

          if (isNotarizationComplete) {
            currentStep = 5;
          }
        }
      }
    }
  }

  return currentStep;
}

export function isSectionComplete(section?: {
  status: QuestionnaireSectionStatus;
}): boolean {
  if (!section) return false;
  return (
    section.status === QuestionnaireSectionStatus.COMPLETED ||
    section.status === QuestionnaireSectionStatus.NOT_APPLICABLE
  );
}
